import { createContext } from 'react';
import { featureEnabled } from '../constants';
import { User } from '../hooks';

export type UserV3Context = {
  data: User;
  featureEnabled: typeof featureEnabled;
  isUniversityUser: boolean;
};

export const userV3Ctx = createContext<UserV3Context | undefined>(undefined);
